import Swal from 'sweetalert2'

// Set Sweet Alert defaults
Swal.mixin({
    cancelButtonText: 'Cancel',
    // confirmButtonColor: '#596f5d',
    // cancelButtonColor: '#d3d3d3',
    confirmButtonText: 'OK!',
})

export default Swal
